module.exports = __webpack_public_path__ + "static/img/bg-id.839ab188.png";